'use client';

import { SvgTruck } from '@common/icon';
import { Fragment, useRef } from 'react';

import { useDynamicSize } from '@/hooks/useDynamicSize';

interface NoticeProps {
  title: string;
  productName?: string;
  content: string;
}

export const Notice = ({ productName, content, title }: NoticeProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const { dynamicSize } = useDynamicSize({ baseWidth: 375, ref });

  // **로 감싸진 텍스트를 <strong> 태그로 변환하는 함수
  const parseNoticeText = (text: string) => {
    // **텍스트** 패턴을 찾아서 분할
    const parts = text.split(/(\*\*.*?\*\*)/g);

    return parts.map((part, index) => {
      // **로 시작하고 끝나는 부분인지 확인
      if (part.startsWith('**') && part.endsWith('**')) {
        // ** 제거하고 strong 태그로 감싸기
        const boldText = part.slice(2, -2);

        return (
          <strong key={index} className="font-700 text-O-500">
            {boldText}
          </strong>
        );
      }

      //* 일반 텍스트는 그대로 반환
      return <Fragment key={index}>{part}</Fragment>;
    });
  };

  return (
    <article
      className="bg-Gray-black"
      ref={ref}
      style={{
        paddingLeft: dynamicSize(36),
        paddingRight: dynamicSize(36),
        paddingTop: dynamicSize(44),
        paddingBottom: dynamicSize(44),
      }}
    >
      <div
        className="flex items-center"
        style={{ gap: dynamicSize(6), marginBottom: dynamicSize(8) }}
      >
        <div
          className="shrink-0 rounded-pill bg-O-500 flex-center"
          style={{ width: dynamicSize(40), height: dynamicSize(40) }}
        >
          <SvgTruck
            className="text-Gray-black"
            style={{ width: dynamicSize(24), height: dynamicSize(24) }}
          />
        </div>
        <span
          className="font-700 text-O-500 typo-body3"
          style={{ fontSize: dynamicSize(16) }}
        >
          {title}
        </span>
      </div>
      {productName ? (
        <p
          className="font-700 text-O-500 typo-body3"
          style={{ fontSize: dynamicSize(16) }}
        >
          {productName}
        </p>
      ) : null}
      <div className="my-20 w-full border-t-1 border-Gray-800" />
      <p
        className="whitespace-pre-line font-700 text-Gray-white typo-h6"
        style={{ fontSize: dynamicSize(22) }}
      >
        {parseNoticeText(content)}
      </p>
    </article>
  );
};
